export default __webpack_public_path__ + "static/media/EconomicsSupplyDemand_10.ab564e99.png";